import AdminHome from './../views/admin/AdminHome.vue'
import AdminUser from './../views/admin/AdminUser.vue'
import AdminParameter from './../views/admin/AdminParameter.vue'
import AdminVendor from "./../views/admin/AdminVendor.vue";
import AdminVendorVerified from "./../views/admin/AdminVendorVerified.vue";
import AdminLokasiProyek from "./../views/admin/AdminLokasiProyek.vue";
import AdminCOA from "./../views/admin/AdminCOA.vue";
import AdminDivisi from "./../views/admin/AdminDivisi.vue";
import AdminBeritaInformasi from "./../views/admin/AdminBeritaInformasi.vue";


const admin = [
  {
    path: '/admin',
    component: AdminHome,
    meta: { auth: true, admin: true }
  },
  {
    path: '/admin/user',
    component: AdminUser,
    meta: { auth: true, admin: true }
  },
  {
    path: '/admin/parameter',
    component: AdminParameter,
    meta: { auth: true, admin: true }
  },
  {
    path: "/admin/vendor",
    component: AdminVendor,
    meta: { auth: true, admin: true }
  },
  {
    path: "/admin/vendor/verified",
    component: AdminVendorVerified,
    meta: { auth: true, admin: true }
  },
  {
    path: "/admin/lokasi-proyek",
    component: AdminLokasiProyek,
    meta: { auth: true, admin: true }
  },
  {
    path: "/admin/coa",
    component: AdminCOA,
    meta: { auth: true, admin: true }
  },
  {
    path: "/admin/divisi",
    component: AdminDivisi,
    meta: { auth: true, admin: true }
  },
  {
    path: "/admin/berita-informasi",
    component: AdminBeritaInformasi,
    meta: { auth: true, admin: true }
  }
]

export default admin